import { render, staticRenderFns } from "./EditarCargo.vue?vue&type=template&id=9254e846&"
import script from "./EditarCargo.vue?vue&type=script&lang=js&"
export * from "./EditarCargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports